import { create } from "zustand";
import { AddressSlice, createAddressSlice } from "./addressStrore";
import { ResultsSlice, createResultsSlice } from "./resultsStore";
import { SearchSlice, createSearchSlice } from "./searchStore";

export const useStore = create<SearchSlice & ResultsSlice & AddressSlice>(
  (...a) => {
    return {
      ...createSearchSlice(...a),
      ...createResultsSlice(...a),
      ...createAddressSlice(...a),
    };
  }
);
